import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":3332";
};

// Merchant Bank List
export const uploadbecomeMerchantDocument = (
  params,
  uuid = null,
  type = null
) => {
  const url = `${baseURL()}/suggestBusiness/document/upload${
    uuid !== null ? (type !== null ? "/" + uuid + "/" + type : "/" + uuid) : ""
  }`;

  return axios.post(url, params, {
    timeout: 180000,
  });
};

export const uploadbecomeMerchantDocumentSingle = (
  params,
  case_id,
  type,
  i,
  setProgress = undefined
) => {
  const url = `${baseURL()}/suggestBusiness/document/uploadSingleDoc/${case_id}`;
  const config = {
    timeout: 180000,
    onUploadProgress: function (progressEvent) {
      var percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      if (setProgress !== undefined) {
        setProgress(type, i, percentCompleted);
      }
    },
  };
  return axios.post(url, params, config);
};
